export default __webpack_public_path__ + "4690fb5c1f2290ec625aff4b89c5e1b2.png";